__turbopack_context__.v({
  "image": "styles-module-scss-module__xMfxvW__image",
  "image3D": "styles-module-scss-module__xMfxvW__image3D",
  "imageContainer": "styles-module-scss-module__xMfxvW__imageContainer",
  "imageContainer3D": "styles-module-scss-module__xMfxvW__imageContainer3D",
  "root": "styles-module-scss-module__xMfxvW__root",
  "rotatingTagSlot": "styles-module-scss-module__xMfxvW__rotatingTagSlot",
  "tag3D": "styles-module-scss-module__xMfxvW__tag3D",
  "tagExclusive": "styles-module-scss-module__xMfxvW__tagExclusive",
  "tagIn": "styles-module-scss-module__xMfxvW__tagIn",
  "tagItem": "styles-module-scss-module__xMfxvW__tagItem",
  "tagJackpot": "styles-module-scss-module__xMfxvW__tagJackpot",
  "tagNew": "styles-module-scss-module__xMfxvW__tagNew",
  "tagOut": "styles-module-scss-module__xMfxvW__tagOut",
  "tagTop": "styles-module-scss-module__xMfxvW__tagTop",
  "title": "styles-module-scss-module__xMfxvW__title",
  "topLeftContainer": "styles-module-scss-module__xMfxvW__topLeftContainer",
  "topRightContainer": "styles-module-scss-module__xMfxvW__topRightContainer",
  "withFavorite": "styles-module-scss-module__xMfxvW__withFavorite",
});
